import { AddGlobalSearchRecentItemUseCase } from './AddGlobalSearchRecentItemUseCase'
import { globalSearchRecentsRepository } from '../../../data-access/repositories'

export const addGlobalSearchRecentItem = new AddGlobalSearchRecentItemUseCase({
  recentsRepository: globalSearchRecentsRepository,
}).execute
